export default "__VITE_ASSET__DwpM4Ibl__"